var DistanceMapPass = (function () {
    function DistanceMapPass() {
    }
    return DistanceMapPass;
}());
export { DistanceMapPass };
